import { apiWarningLevelToEnum, type UnifiedVaultWarningLevel } from '@/helpers/warnings'

/** Procedures carry the warning level as Core's lowercase string; anything else scores green. */
export function toWarningLevel(level: string): UnifiedVaultWarningLevel {
  return apiWarningLevelToEnum(level === 'red' || level === 'yellow' ? level : 'green')
}
